<template>
  <div class="w-full px-4 mt-5 centrarElemento">
                <div class="mt-10 lg:mt-0">
                    <span class="mb-4 block text-lg font-semibold text-primary-500">
                        Este es un sitio de pruebas
                    </span>
                    <h2 class="mb-5 text-3xl font-bold text-neutral-700 sm:text-[40px]/[48px]">
                        Aquí se encuentra el listado de empleados.
                    </h2>
                    <p class="mb-5 text-base text-neutral-500">
                      Cuando se realice la correcta conexión con el modelo de negocio del sistema y la base de datos, aquí se encontrará la lista de empleados, y se podrán asignar sus tareas correspondientes.
                    </p>
                    <p class="mb-8 text-base text-neutral-500">
                      Este mensaje solo se visualizará en el modelo de ejemplo del sitio.
                    </p>
                </div>
            </div>
  <ul role="list" class="divide-y divide-gray-100">
    <li v-for="person in data" :key="person.id" class="flex justify-between gap-x-6 py-5">
      <div class="flex min-w-0 gap-x-4">
        <img class="h-12 w-12 flex-none rounded-full bg-gray-50" src="/img/logo.png" alt="" />
        <div class="min-w-0 flex-auto">
          <p class="text-sm font-semibold leading-6 text-gray-900">{{ person.name }}</p>
          <p class="mt-1 truncate text-xs leading-5 text-gray-500">{{ person.email }}</p>
        </div>
      </div>
      <div class="hidden shrink-0 sm:flex sm:flex-col sm:items-end">
        <p class="text-sm leading-6 text-gray-900">{{ person.role }}</p>
        <p v-if="person.lastSeen" class="mt-1 text-xs leading-5 text-gray-500">
          Last seen <time :datetime="person.lastSeenDateTime">{{ person.lastSeen }}</time>
        </p>
        <div v-else class="mt-1 flex items-center gap-x-1.5">
          <div class="flex-none rounded-full bg-emerald-500/20 p-1">
            <div class="h-1.5 w-1.5 rounded-full bg-emerald-500" />
          </div>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
  export default {
    data() {
      return {
        data: ''
      };
    },
    async created() {
      try {
        const response = await fetch('http://127.0.0.1:8000/api/users');
        const data = await response.json();
        this.data = data;
      } catch (error) {
        console.error('Error al obtener datos:', error);
      }
    }
  }
</script>
  